import {
	AppPage,
	MimaDateFilter,
	MimaFilter,
	MimaText,
	PageLoader,
	MimaButton,
	MimaDropdownFilter,
} from '../../components';
import styles from '../../assets/styles/AppHome/AppHome.module.scss';
import ProgressBar from '@ramonak/react-progress-bar';
import { IoIosCheckmarkCircle, IoMdCloseCircle } from 'react-icons/io';
import QuickLinksCard from './QuickLinksCard';
import { MdCancel } from 'react-icons/md';
import { businessStore, transactionStore, userStore } from '../../stores';
import React, { useState } from 'react';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import { AnimatePresence } from 'framer-motion';
import {
	SecurityContainer,
	WithdrawalAccountContainer,
} from '../../containers';
import constant from '../../utils/constant';
import Survey from '../../components/Survey/Survey';

const AppHome = ({
	tradingName,
	transactionsSummary,
	loading,
	onSubmit,
	validationSchema,
	filterPeriod,
	resetFilter,
	toDoListTotal,
	isActivated,
	hasPin,
	refresh,
	hasWithdrawal,
	closeModal,
	reportModal,
	viewReport,
	goToSetPin,
	goToWithdrawalAccount,
	pinModal,
	withdrawalAccountModal,

	filterPeriods,
	getDate,
}) => {
	const [onReset, setOnReset] = useState(false);
	const [showSurvey, setShowSurvey] = useState(false);
	const permissions = new Set(
		toJS(userStore.user?.permissions?.map(perm => perm.name))
	);
	const [curr, setCurr2] = useState(
		businessStore.defaultCurrency
			? businessStore.defaultCurrency
			: transactionsSummary[0]?.currencyCode
	);

	return (
		<AppPage tradingName={tradingName} refresh={refresh}>
			{loading ? (
				<PageLoader title="Refreshing record..." loading={loading} />
			) : (
				<>
					<MimaText variant="subtitle" mb={2} align="center">
						You are viewing Insights for {filterPeriod}.
					</MimaText>

					<div className={styles.homeTop}>
						<Formik
							initialValues={{
								startDate: '',
								endDate: '',
								period: '',
								periodText: '',
							}}
							validationSchema={validationSchema}
							onSubmit={onSubmit}>
							{({
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<MimaFilter
									filterClick={() => {
										setOnReset(false);
										handleSubmit();
									}}
									loading={loading}
									resetClick={() => {
										setOnReset(true);
										resetFilter();
									}}>
									<div style={{ display: 'flex', flexDirection: 'column' }}>
										<MimaDropdownFilter
											labelTitle="Filter period"
											placeholder="Select Period"
											variant="medium"
											name="period"
											data={filterPeriods}
											onChange={data => {
												const dates = getDate(data.key);
												setFieldValue('period', data.key);
												setFieldValue('startDate', dates.startDate);
												setFieldValue('endDate', dates.endDate);
												setFieldValue('periodText', data.value);
											}}
											error={errors.period}
											touched={touched.period}
										/>

										{values.period === 'custom' && (
											<div style={{ display: 'flex', gap: '2rem' }}>
												<MimaDateFilter
													labelTitle="start date"
													name="startDate"
													value={!onReset ? values.startDate : ''}
													onChange={text => {
														setOnReset(false);
														setFieldValue('startDate', text);
													}}
													onBlur={handleBlur}
													width={18}
													touched={touched.startDate}
													error={errors.startDate}
												/>
												<MimaDateFilter
													labelTitle="End date"
													name="endDate"
													value={!onReset ? values.endDate : ''}
													onChange={text => {
														setOnReset(false);
														setFieldValue('endDate', text);
													}}
													onBlur={handleBlur}
													width={18}
													touched={touched.endDate}
													error={errors.endDate}
												/>
											</div>
										)}
									</div>
								</MimaFilter>
							)}
						</Formik>
					</div>

					<div className={styles.main}>
						<QuickLinksCard viewReport={viewReport} />
						{permissions.has('CAN CREATE BUSINESS WITHDRAWAL ACCOUNT') &&
						toDoListTotal < 100 ? (
							<div className={styles.toDo}>
								<MimaText variant="smallBold" mb={1}>
									You are almost done!
								</MimaText>
								<div className={styles.toDo__group}>
									<div className={styles.toDo__items}>
										<p>Activate Account</p>
										<span className={isActivated ? styles.toDo__green : ''}>
											{isActivated ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div>
									{/* <div
								className={
									isOnboarded ? styles.toDo__items : styles.toDo__items_hover
								}
								onClick={goToOnboarding}>
								<p> Verification </p>
								<span className={isOnboarded ? styles.toDo__green : ''}>
									{isOnboarded ? <IoIosCheckmarkCircle /> : <MdCancel />}
								</span>
							</div> */}
									<div
										className={
											hasPin ? styles.toDo__items : styles.toDo__items_hover
										}
										onClick={!hasPin ? goToSetPin : () => {}}>
										<p> Set Transaction Pin</p>
										<span className={hasPin ? styles.toDo__green : ''}>
											{hasPin ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div>
									<div
										className={
											hasWithdrawal
												? styles.toDo__items
												: styles.toDo__items_hover
										}
										onClick={!hasWithdrawal && goToWithdrawalAccount}>
										<p>Set Withdrawal Account</p>
										<span className={hasWithdrawal ? styles.toDo__green : ''}>
											{hasWithdrawal ? <IoIosCheckmarkCircle /> : <MdCancel />}
										</span>
									</div>
								</div>
								<ProgressBar
									completed={toDoListTotal}
									bgColor="var(--color-success)"
									animateOnRender
								/>
							</div>
						) : (
							''
						)}
					</div>

					{(
						reportModal ||
						pinModal ||
						withdrawalAccountModal ||
						showSurvey) && (
						<div className="modal">
							<AnimatePresence>
								{pinModal && <SecurityContainer closeModal={closeModal} />}
								{withdrawalAccountModal && (
									<WithdrawalAccountContainer closeModal={closeModal} />
								)}
								{showSurvey && (
									<Survey
										title=""
										reviewId={userStore.reviewId}
										closeModal={() => {
											setShowSurvey(false);
										}}
									/>
								)}
							</AnimatePresence>
						</div>
					)}
				</>
			)}
		</AppPage>
	);
};

export default AppHome;
